import $ from "jquery";
import Swiper from "swiper";

/**
 * Configurazione per i breakpoints degli Swiper
 */
interface SwiperBreakpoints {
    [width: number]: {
        slidesPerView: number;
    };
}

/**
 * Opzioni aggiuntive per la configurazione Swiper
 */
interface SwiperOptions {
    allowTouch: boolean;
}

/**
 * Configurazione standard per Foto e Planimetrie
 */
export const STANDARD_BREAKPOINTS: SwiperBreakpoints = {
    576: { slidesPerView: 3.5 },
    768: { slidesPerView: 4.5 },
    992: { slidesPerView: 5.5 },
    1200: { slidesPerView: 6.5 }
};

/**
 * Configurazione ridotta per Compare, Virtual Tour e Video
 */
export const REDUCED_BREAKPOINTS: SwiperBreakpoints = {
    576: { slidesPerView: 2.5 },
    768: { slidesPerView: 2.5 },
    992: { slidesPerView: 3.5 },
    1200: { slidesPerView: 4.5 }
};

/**
 * Inizializza una coppia di Swiper (thumbs + main)
 * @param thumbSelector Selettore per lo swiper delle thumbnail
 * @param mainSelector Selettore per lo swiper principale
 * @param breakpoints Configurazione breakpoints per le thumbnail
 * @param options Opzioni aggiuntive
 */
export function initSwiperPair(
    thumbSelector: string,
    mainSelector: string,
    breakpoints: SwiperBreakpoints,
    options: SwiperOptions
): void {
    if ($(thumbSelector).length > 0) {
        // Swiper per le thumbnail
        const thumbSwiper = new Swiper(thumbSelector, {
            spaceBetween: 4,
            slidesPerView: 2.5,
            freeMode: true,
            watchSlidesProgress: true,
            breakpoints: breakpoints as any // ✅ Cast esplicito per compatibilità con Swiper
        });

        // Swiper principale con navigazione scopata al container
        const mainEl = document.querySelector<HTMLElement>(mainSelector);
        new Swiper(mainSelector, {
            spaceBetween: 0,
            simulateTouch: options.allowTouch,
            allowTouchMove: options.allowTouch,
            navigation: {
                nextEl: mainEl?.querySelector<HTMLElement>('.swiper-button-next') ?? '.swiper-button-next',
                prevEl: mainEl?.querySelector<HTMLElement>('.swiper-button-prev') ?? '.swiper-button-prev'
            },
            thumbs: {
                swiper: thumbSwiper
            }
        });
    }
}

/**
 * Inizializza tutti gli Swiper presenti nella scheda vendita
 */
export function initAllSwipers(): void {
    // Inizializza Swiper Foto
    initSwiperPair(
        "#swiperSchedaThumbFoto",
        "#swiperSchedaImgFoto",
        STANDARD_BREAKPOINTS,
        { allowTouch: true }
    );

    // Inizializza Swiper Compare
    initSwiperPair(
        "#swiperSchedaThumbCompare",
        "#swiperSchedaImgCompare",
        REDUCED_BREAKPOINTS,
        { allowTouch: false }
    );

    // Inizializza Swiper Planimetrie
    initSwiperPair(
        "#swiperSchedaThumbPlanimetrie",
        "#swiperSchedaImgPlanimetrie",
        STANDARD_BREAKPOINTS,
        { allowTouch: true }
    );

    // Inizializza Swiper Virtual Tour
    initSwiperPair(
        "#swiperSchedaThumbVirtual",
        "#swiperSchedaImgVirtual",
        REDUCED_BREAKPOINTS,
        { allowTouch: false }
    );

    // Inizializza Swiper Video
    initSwiperPair(
        "#swiperSchedaThumbVideo",
        "#swiperSchedaImgVideo",
        REDUCED_BREAKPOINTS,
        { allowTouch: false }
    );
}
